
<template>
    <div>
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="item.path" v-for="(item, index) in breadcrumbList" :key="index">{{ item.name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 搜索筛选 -->
      <el-form :inline="true" :model="formInline" class="user-search">
       
        <el-form-item label="支付平台：">
                <el-select style="width: 100px;" size="small" v-model="formInline.type" placeholder="请选择">
                    <el-option v-for="type in type" :label="type.key" :value="type.value"
                        :key="type.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="订单状态：">
                <el-select style="width: 100px;" size="small" v-model="formInline.state" placeholder="请选择">
                    <el-option v-for="type in state" :label="type.key" :value="type.value"
                        :key="type.value"></el-option>
                </el-select>
            </el-form-item>
        <el-form-item>
          <el-form-item label="搜索：">
          <el-input size="small" v-model="formInline.no" placeholder="输入订单号或手机号"></el-input>
        </el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
      <!--列表-->
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
        style="width: 100%;">
        <el-table-column align="center" type="selection" width="40">
        </el-table-column>
        <el-table-column prop="boid" label="ID" width="60">
        </el-table-column>
        <el-table-column prop="name" label="商品名称" width="auto">
        </el-table-column>
        <el-table-column prop="type" label="支付平台" width="100">
          <template slot-scope="{row}">
            <div v-if="row.type == 0"  >微信</div>
            <div v-else-if="row.type == 1"  >抖音</div>
          </template>
        </el-table-column>
        <el-table-column prop="money" label="商品价格" width="auto">
        </el-table-column>
        <el-table-column prop="no" label="订单号" width="auto">
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="auto">
        </el-table-column>
        <el-table-column prop="state" label="订单状态" width="auto">
          <template slot-scope="{row}">
            <div v-if="row.state == 0"  >未支付</div>
            <div v-else-if="row.state == 1"  >已支付</div>
            <div v-else>支付失败</div>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="auto">
        </el-table-column>
        <el-table-column prop="update_time" label="支付时间" width="auto">
        </el-table-column>
        <!-- <el-table-column align="center" label="操作" min-width="140">
          <template slot-scope="scope">
            <el-button size="mini"  type="primary" @click="update(scope.row)"><i class="el-icon-edit" />修改</el-button>
            <el-button size="mini" type="danger" @click="del(scope.row)"><i class="el-icon-delete" />删除</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      <!-- <Add :show.sync="dialog.addDialogStatus" @refesh_list="getdata"></Add> -->
      <!-- <Update :info="updateInfo" :show.sync="dialog.updateDialogStatus" size="small" @refesh_list="getdata"></Update> -->
    </div>
  </template>
  
  <script>
  import { getOrder } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  // import Update from './update.vue'
  // import Add from './add.vue'
  export default {
    // 注册组件
    components: {
      Pagination
    },
    data() {
      return {
        type: [ //0待完结 1已完结
              { key: '请选择', value: '' },
              { key: '微信', value: 0 },
              { key: '抖音', value: 1 },
          ],
          state: [ //0抖音 1快手
              { key: '请选择', value: '' },
              { key: '未支付', value: 0 },
              { key: '已支付', value: 1 },
              { key: '支付失败', value: 2 },
          ],
        dialog: {
          addDialogStatus: false,
          updateDialogStatus: false
        },
        breadcrumbList:[],
        updateInfo: {},
        loading: false, //是显示加载
        formInline: {
          no:'',
          page: 1
        },
        listData: [],
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    created() {
      this.getdata()
      this.generateBreadcrumb()
    },
    watch: {
      $route() {
        this.generateBreadcrumb()
      }
    },
    methods: {
      search(){
        this.formInline.page = 1
        this.getdata(this.formInline)
      },
      generateBreadcrumb() {
        // 获取当前路由信息
        const matched = this.$route.matched
        console.log(matched,'++++++++++');
        // 初始化面包屑导航数据
        const breadcrumbList = []
        // 遍历路由信息，生成面包屑导航数据
        matched.forEach(item => {
          const { meta, name, path } = item
          if (meta.requireAuth) {
            breadcrumbList.push({
              name,
              path
            })
          }
        })
        console.log(breadcrumbList,'=========');
        // 保存面包屑导航数据
        this.breadcrumbList = breadcrumbList
      },
      getdata() {
        this.loading = true
        getOrder(this.formInline).then(res => {
          console.log(res);
          if (res.code == 200) {
            this.listData = res.trainer.data
            this.pageparm.total = res.trainer.total
            this.loading = false
  
          }
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
    }
  }
  </script>
  
  <style scoped>
  .user-search {
    margin-top: 20px;
  }
  
  .userRole {
    width: 100%;
  }
  </style>
  
   
   


// WEBPACK FOOTER //
// src/views/pay/order.vue